module.exports = __webpack_public_path__ + "img/birthdayPresent.bcd11eda.png";